import React, { forwardRef } from "react";
import CodingChallenge from "./CodingChallenge";
import { normalizeSampleCode } from "../../utils/judgeLanguages";

/**
 * What the sandbox hands its challenge, from a question as the database stores it. The
 * laptop sandbox builds its challenge through this too, so `/s/sandbox` is the same
 * challenge on both screens.
 */
export const sandboxChallenge = ({ sampleCode, testCases } = {}) => ({
  challengeId: "most-frequent-word",
  // Convert sampleCode keys from DB format ("JavaScript", "C++") to Monaco IDs ("javascript", "cpp")
  sampleCode: normalizeSampleCode(sampleCode),
  testCases: (testCases || []).map(tc => ({
    input: tc.input,
    expected: tc.expectedOutput,
    isHidden: tc.isHidden || false,
  })),
});

const Sandbox = forwardRef(({ sampleCode, question, testCases, description, onSubmit, disabled }, ref) => {
  const challenge = sandboxChallenge({ sampleCode, testCases });

  return (
    <CodingChallenge
      challengeId={challenge.challengeId}
      question={question}
      sampleCode={challenge.sampleCode}
      testCases={challenge.testCases}
      description={description}
      onSubmit={onSubmit}
      disabled={disabled}
      ref={ref}
    />
  );
});

export default Sandbox;
